import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import iso from "../../assets/isoc.avif";
import iso1 from "../../assets/iso.avif";
import {
  MdKeyboardArrowDown,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
  MdPhone,
  MdEmail,
  MdMenu,
  MdClose,
} from "react-icons/md";
import img from "../../assets/Logo.avif";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesHover, setServicesHover] = useState(false);
  const [servicesMobileOpen, setServicesMobileOpen] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFlipped((prev) => !prev);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handlePhoneClick = (phoneNumber) => {
    window.location.href = `tel:${phoneNumber.replace(/\D/g, "")}`;
  };

  const closeAllMenus = () => {
    setMenuOpen(false);
    setServicesHover(false);
    setServicesMobileOpen(false);
  };

  return (
    <>
      {/* Top Contact Bar - Improved responsive layout */}
      <div className="bg-gray-900 text-white text-sm py-2 px-4">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-2">
          <div className="flex flex-wrap justify-center md:justify-start gap-4 md:gap-6 lg:gap-[70px]">
            <button
              onClick={() => handlePhoneClick("+(91)99945 23799")}
              className="flex items-center gap-1 hover:text-blue-400 transition-colors whitespace-nowrap"
            >
              <MdPhone className="text-blue-400" /> + (91) 99945 23799
            </button>
            <button
              onClick={() => handlePhoneClick("+(91)96554 42269")}
              className="flex items-center gap-1 hover:text-blue-400 transition-colors whitespace-nowrap"
            >
              <MdPhone className="text-blue-400" /> + (91) 96554 42269
            </button>
            <span className="flex items-center gap-1 whitespace-nowrap">
              <MdEmail className="text-blue-400" />
              <a
                href="mailto:info@3dtechproto.com"
                className="hover:text-blue-400 transition-colors"
              >
                info@3dtechproto.com
              </a>
            </span>
          </div>
          <Link
            to="/contact"
            className="bg-blue-600 hover:bg-blue-700 px-3 py-1 rounded-md flex items-center gap-1 transition-colors whitespace-nowrap"
          >
            <MdPhone /> Contact Us
          </Link>
        </div>
      </div>

      {/* Main Navbar - Improved responsive structure */}
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          {/* Logo */}
          <div
            className="flex items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img src={img} alt="3DE Logo" className="h-10 sm:h-12" />
          </div>

          {/* Desktop Navigation - Better spacing */}
          <div className="hidden lg:flex items-center space-x-4 xl:space-x-6">
            <Link
              to="/"
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap"
            >
              Home
            </Link>
            <Link
              to="/about"
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap"
            >
              About Us
            </Link>

            {/* Desktop Services Dropdown - Improved positioning */}
            <div
              className="relative group"
              onMouseEnter={() => setServicesHover(true)}
              onMouseLeave={() => setServicesHover(false)}
            >
              <button className="flex items-center text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap">
                Services
                {servicesHover ? (
                  <MdKeyboardArrowUp className="ml-1" />
                ) : (
                  <MdKeyboardArrowDown className="ml-1" />
                )}
              </button>

              <div
                className={`absolute left-0 w-56 bg-white rounded-md shadow-lg py-1 z-50 transition-all duration-200 ${
                  servicesHover
                    ? "opacity-100 visible translate-y-0"
                    : "opacity-0 invisible -translate-y-2"
                }`}
              >
                {/* 3D Printing Submenu */}
                <div className="relative group">
                  <button className="w-full flex justify-between items-center px-4 py-2 text-gray-700 hover:bg-gray-100">
                    <span>3D Printing</span>
                    <MdKeyboardArrowRight />
                  </button>
                  <div className="absolute left-full top-0 ml-1 w-56 bg-white rounded-md shadow-lg py-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                    <Link
                      to="/sla-3d-printing"
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                      onClick={closeAllMenus}
                    >
                      SLA 3D Printing
                    </Link>
                    <Link
                      to="/sls-3d-printing"
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                      onClick={closeAllMenus}
                    >
                      SLS 3D Printing
                    </Link>
                    <Link
                      to="/dlp-3d-printing"
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                      onClick={closeAllMenus}
                    >
                      DLP 3D Printing
                    </Link>

                    <Link
                      to="/mjf-3d-printing"
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                      onClick={closeAllMenus}
                    >
                      MJF 3D Printing
                    </Link>
                    <Link
                      to="/fdm-3d-printing"
                      className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                      onClick={closeAllMenus}
                    >
                      FDM 3D Printing
                    </Link>
                  </div>
                </div>

                <Link
                  to="/vacuum-casting"
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={closeAllMenus}
                >
                  Vacuum Casting
                </Link>
                <Link
                  to="/injection-molding"
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={closeAllMenus}
                >
                  Injection Molding
                </Link>
                <Link
                  to="/available-materials"
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={closeAllMenus}
                >
                  Available Materials
                </Link>
                <Link
                  to="/rapidToolingSection"
                  className="block px-4 py-2 text-gray-700 hover:bg-gray-100"
                  onClick={closeAllMenus}
                >
                  Proto Tooling
                </Link>
              </div>
            </div>
            <Link
              to="/contractManufacturing"
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap"
            >
              Contract Manufacturing
            </Link>
            <Link
              to="/extra-discount"
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap"
            >
              Offers
            </Link>
            <Link
              to="/contact"
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap"
            >
              Contact Us
            </Link>
            <Link
              to="/careers"
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap"
            >
              Careers
            </Link>
            <Link
              to="/quotation"
              className="text-gray-700 hover:text-blue-600 font-medium transition-colors whitespace-nowrap"
            >
              Instance Quotation
            </Link>
          </div>

          {/* Flip Card - Improved responsive sizing */}
          <div className="hidden md:flex items-center mx-2 lg:mx-4">
            <div className="flip-card-container w-12 h-12 lg:w-14 lg:h-14">
              <div className={`flip-card ${isFlipped ? "flipped" : ""}`}>
                <div className="flip-card-front">
                  <img
                    src={iso}
                    alt="Certification 1"
                    className="w-full h-full object-contain rounded-lg"
                  />
                </div>
                <div className="flip-card-back">
                  <img
                    src={iso1}
                    alt="Certification 2"
                    className="w-full h-full object-contain rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button - Better responsive visibility */}
          <Link
            to="/extra-discount"
            className="hidden md:block bg-gradient-to-r from-blue-600 to-blue-800 text-white px-3 py-1.5 lg:px-4 lg:py-2 rounded-md font-medium hover:from-blue-700 hover:to-blue-900 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Get a Better Deal
          </Link>

          {/* Mobile Menu Button - Improved touch target */}
          <button
            className="lg:hidden text-gray-700 focus:outline-none p-1"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {menuOpen ? (
              <MdClose className="w-6 h-6" />
            ) : (
              <MdMenu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu - Improved transitions and scrolling */}
        <div
          className={`lg:hidden bg-white shadow-lg overflow-hidden transition-all duration-300 ease-in-out ${
            menuOpen ? "max-h-[80vh] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="container mx-auto px-4 py-2 flex flex-col space-y-2 overflow-y-auto max-h-[calc(80vh-60px)]">
            <Link
              to="/"
              className="block py-2 text-gray-700 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
              onClick={closeAllMenus}
            >
              Home
            </Link>
            <Link
              to="/about"
              className="block py-2 text-gray-700 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
              onClick={closeAllMenus}
            >
              About Us
            </Link>

            {/* Mobile Services Dropdown - Improved UX */}
            <div className="relative">
              <button
                className="flex justify-between items-center w-full py-2 text-gray-700 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
                onClick={() => setServicesMobileOpen(!servicesMobileOpen)}
              >
                <span>Services</span>
                {servicesMobileOpen ? (
                  <MdKeyboardArrowUp />
                ) : (
                  <MdKeyboardArrowDown />
                )}
              </button>

              <div
                className={`overflow-hidden transition-all duration-200 ${
                  servicesMobileOpen ? "max-h-[500px]" : "max-h-0"
                }`}
              >
                {/* 3D Printing Submenu */}
                <div className="relative pl-2">
                  <button
                    className="flex justify-between items-center w-full py-2 text-gray-600 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
                    onClick={() => setServicesMobileOpen(!servicesMobileOpen)}
                  >
                    <span>3D Printing</span>
                    <MdKeyboardArrowRight />
                  </button>

                  <div className="pl-4">
                    <Link
                      to="/sla-3d-printing"
                      className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
                      onClick={closeAllMenus}
                    >
                      SLA 3D Printing
                    </Link>
                    <Link
                      to="/sls-3d-printing"
                      className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
                      onClick={closeAllMenus}
                    >
                      SLS 3D Printing
                    </Link>
                    <Link
                      to="/dlp-3d-printing"
                      className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
                      onClick={closeAllMenus}
                    >
                      DLP 3D Printing
                    </Link>
                    <Link
                      to="/mjf-3d-printing"
                      className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
                      onClick={closeAllMenus}
                    >
                      MJF 3D Printing
                    </Link>
                    <Link
                      to="/fdm-3d-printing"
                      className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
                      onClick={closeAllMenus}
                    >
                      FDM 3D Printing
                    </Link>
                  </div>
                </div>

                <Link
                  to="/vacuum-casting"
                  className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2 pl-4"
                  onClick={closeAllMenus}
                >
                  Vacuum Casting
                </Link>
                <Link
                  to="/injection-molding"
                  className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2 pl-4"
                  onClick={closeAllMenus}
                >
                  Injection Molding
                </Link>
                <Link
                  to="/available-materials"
                  className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2 pl-4"
                  onClick={closeAllMenus}
                >
                  Available Materials
                </Link>
                <Link
                  to="/rapidToolingSection"
                  className="block py-2 text-gray-600 hover:text-blue-600 hover:bg-gray-50 rounded px-2 pl-4"
                  onClick={closeAllMenus}
                >
                  Proto Tooling
                </Link>
              </div>
            </div>

            <Link
              to="/extra-discount"
              className="block py-2 text-gray-700 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
              onClick={closeAllMenus}
            >
              Offers
            </Link>
            <Link
              to="/contact"
              className="block py-2 text-gray-700 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
              onClick={closeAllMenus}
            >
              Contact Us
            </Link>
            <Link
              to="/careers"
              className="block py-2 text-gray-700 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
              onClick={closeAllMenus}
            >
              Careers
            </Link>
            <Link
              to="/quotation"
              className="block py-2 text-gray-700 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
              onClick={closeAllMenus}
            >
              Instance Quotation
            </Link>
            <Link
              to="/contractManufacturing"
              className="block py-2 text-gray-700 border-b border-gray-100 hover:text-blue-600 hover:bg-gray-50 rounded px-2"
              onClick={closeAllMenus}
            >
              Contract Manufacturing
            </Link>

            <Link
              to="/extra-discount"
              className="my-2 bg-gradient-to-r from-blue-600 to-blue-800 text-white px-4 py-2 rounded-md font-medium text-center hover:from-blue-700 hover:to-blue-900 transition-all"
              onClick={closeAllMenus}
            >
              Get a Better Deal
            </Link>
          </div>
        </div>
      </nav>

      {/* Flip Card Styles - Improved for responsive */}
      <style>{`
        .flip-card-container {
          perspective: 1000px;
        }
        .flip-card {
          position: relative;
          width: 100%;
          height: 100%;
          transition: transform 0.6s;
          transform-style: preserve-3d;
        }
        .flip-card.flipped {
          transform: rotateY(180deg);
        }
        .flip-card-front,
        .flip-card-back {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .flip-card-back {
          transform: rotateY(180deg);
        }
      `}</style>
    </>
  );
};

export default Navbar;
